__turbopack_context__.v({
  "carousel": "ImageCarousel-module-scss-module__S1ATPq__carousel",
  "carouselSection": "ImageCarousel-module-scss-module__S1ATPq__carouselSection",
  "control": "ImageCarousel-module-scss-module__S1ATPq__control",
  "controls": "ImageCarousel-module-scss-module__S1ATPq__controls",
  "image": "ImageCarousel-module-scss-module__S1ATPq__image",
  "indicator": "ImageCarousel-module-scss-module__S1ATPq__indicator",
  "indicators": "ImageCarousel-module-scss-module__S1ATPq__indicators",
  "link": "ImageCarousel-module-scss-module__S1ATPq__link",
  "slide": "ImageCarousel-module-scss-module__S1ATPq__slide",
  "viewport": "ImageCarousel-module-scss-module__S1ATPq__viewport",
});
